import type {Evaluator, NodeParameters} from "@cm/graph-v3"
import {GraphNode} from "@cm/graph-v3"
import {skipped} from "#template/template-node/constants"
import {visitNone} from "#template/template-node/visit-helpers"
import type {OnCompileContext, OnFilterActiveContext, TemplateNodeContext, VisitorNodeResult} from "#template/template-node/types"

export abstract class TemplateNode<
    out Parameters extends NodeParameters = NodeParameters,
    out ConstructorParameters extends NodeParameters = Parameters,
> extends GraphNode<VisitorNodeResult<Parameters>, TemplateNodeContext, Parameters, ConstructorParameters> {
    override runSync = (evaluator: Evaluator<TemplateNodeContext>): VisitorNodeResult<Parameters> => {
        const {context} = evaluator
        if (context.skipNode?.(this)) return skipped
        const result = this.dispatch(context, evaluator)
        if (result !== skipped) context.onPostUnskippedNode?.(this)
        return result
    }

    private dispatch(context: TemplateNodeContext, evaluator: Evaluator<TemplateNodeContext>): VisitorNodeResult<Parameters> {
        switch (context.type) {
            case "onFilterActive":
                return this.onFilterActive(context, evaluator)
            case "onCompile":
                return this.onCompile(context, evaluator)
        }
    }

    onFilterActive(context: OnFilterActiveContext, evaluator: Evaluator<TemplateNodeContext>): VisitorNodeResult<Parameters> {
        return visitNone(this.parameters)
    }

    onCompile(context: OnCompileContext, evaluator: Evaluator<TemplateNodeContext>): VisitorNodeResult<Parameters> {
        return visitNone(this.parameters)
    }
}
